document.addEventListener('DOMContentLoaded', async () => {
  try {
    const response = await fetch('/wp-json/wp/v2/vacature?status=publish');
    const data = await response.json();
    const publishedVacanciesCount = data.filter(
      (vacature) => vacature.status === 'publish'
    ).length;

    if (publishedVacanciesCount > 0) {
      const jobCountSpan = document.createElement('span');
      jobCountSpan.classList.add('job-count');
      jobCountSpan.textContent = ` ${publishedVacanciesCount}`;

      const workAtElements = document.querySelectorAll('.work-at');
      workAtElements.forEach((element) => {
        element.appendChild(jobCountSpan.cloneNode(true));
      });
    }
  } catch (error) {
    console.error('Error:', error);
  }
});
